module.exports = __webpack_public_path__ + "assets/ff0af5f11260d5ec7124f5faf0a5b2f0.mp4";